<br><br>
<div>
  <div>
    <div class="chart">
      <canvas baseChart
        [data]="pieChartDataWork"
        [labels]="pieChartLabelsWork"
        [options]="pieChartOptionsWork"
        [plugins]="pieChartPluginsWork"
        [legend]="pieChartLegendWork"
        (chartClick)="chartClicked($event)">
      </canvas>
      <!-- <canvas baseChart
        [data]="pieChartData"
        [labels]="pieChartLabels"
        [chartType]="pieChartType"
        [options]="pieChartOptions"
        [plugins]="pieChartPlugins"
        [colors]="pieChartColors"
        [legend]="pieChartLegend"
        (chartClick)="chartClicked($event)">
      </canvas> -->
    </div>
  </div>
</div>
